import { breakpoints, formatForId, getRandomInteger, stripTags } from '../../scripts/utils';
import { toggleAccordion } from '../accordion/accordion';

const tableOfContentClass = 'c-table-of-content';
const itemClass = tableOfContentClass + '__item';
const linkClass = tableOfContentClass + '__link';

const tableOfContentJsClass = 'js-table-of-content';
const listJsClass = tableOfContentJsClass + '-list';
const anchorJsClass = tableOfContentJsClass + '-anchor';

const layoutJsClass = 'js-layout';
const sidebarJsClass = layoutJsClass + '-sidebar';

const tableOfContentElement = document.querySelector('.' + tableOfContentJsClass) as HTMLElement;
const listElement = document.querySelector('.' + listJsClass) as HTMLElement;
const anchorElements = document.querySelectorAll('.' + anchorJsClass) as NodeListOf<HTMLElement>;
const sidebarElement = document.querySelector('.' + sidebarJsClass) as HTMLElement;

// If there are anchors in the page
if (tableOfContentElement && listElement && sidebarElement) {
    // Setup the accoridon
    window.addEventListener('load', () => {
        // If the screen is large enough
        if (window.innerWidth >= breakpoints.xxl) {
            // Open the accordion
            toggleAccordion(null, tableOfContentElement);
        }
    });

    if (anchorElements.length > 0) {
        // Create the links for each anchor
        anchorElements.forEach((anchorElement) => {
            createAnchorLink(anchorElement);
        });
    } else {
        sidebarElement.style.display = 'none';
    }

}

function createAnchorLink (anchorElement: HTMLElement): void {
    // Create a unique id for the anchor using it's content and a random number to avoid duplicates
    anchorElement.id = `${formatForId(anchorElement.innerText)}-${getRandomInteger(100000, 999999)}`;

    // Create a list item
    const itemElement = document.createElement('li');
    itemElement.classList.add(itemClass);

    // Create a link
    const linkElement = document.createElement('a');
    linkElement.classList.add(linkClass);

    // Set the link's href to the corresponding anchor
    const hash = '#' + anchorElement.id;
    linkElement.href = window.location.origin + window.location.pathname + hash;

    // Get the anchor's text and remove any unwanted tags
    const anchorText = stripTags(anchorElement.innerHTML);

    // Set the link's text to the anchor's text
    linkElement.innerHTML = anchorText;

    // Put the link inside the item
    itemElement.appendChild(linkElement);

    // Put the item inside the list
    listElement.appendChild(itemElement);
}